module.exports = __webpack_public_path__ + "static/media/success.958951cb.svg";